export const environment = {
  production: true,
  baseUrl:'https://xpandretail.online/api/', //just for now
  // baseUrl:'http://13.233.38.28/api/', //just for now
  language: "https://xpandretail.online/assets/i18n/",
  footFallKpiGroupId : "5a41fd655bca800604b140cc",
  googleMapAPIKey:"AIzaSyCSHxrflIRZl9HAoTeyzUl47J61hA4B1sE",
  googleMapUrl:"https://maps.googleapis.com/maps/api/"
};



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/environments/environment.ts